import { render, staticRenderFns } from "./entityAssignedToSupervisorNotificationItem.vue?vue&type=template&id=2f048eb7"
import script from "./entityAssignedToSupervisorNotificationItem.vue?vue&type=script&lang=ts"
export * from "./entityAssignedToSupervisorNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports